import * as React from "react";
import { cn } from "@/lib/utils";

export type StatusKey = "green" | "yellow" | "red";

const VARIANTS = {
  default: "bg-primary text-primary-foreground border-transparent",
  secondary: "bg-secondary text-secondary-foreground border-transparent",
  outline: "bg-transparent text-foreground border-border",
} as const;

// Status badges pair a soft tint, AA-safe text color, and a status border.
const STATUS: Record<StatusKey, string> = {
  green: "bg-status-green-bg text-status-green-text border-status-green",
  yellow: "bg-status-yellow-bg text-status-yellow-text border-status-yellow",
  red: "bg-status-red-bg text-status-red-text border-status-red",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: keyof typeof VARIANTS;
  status?: StatusKey;
}

export function Badge({
  className,
  variant = "default",
  status,
  ...props
}: BadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold leading-normal",
        status ? STATUS[status] : VARIANTS[variant],
        className
      )}
      {...props}
    />
  );
}
